import { createFileRoute } from "@tanstack/react-router";
import { DataCatalogListPage } from "../../../components/system/DataCatalogListPage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/data-catalog/")({
  beforeLoad: requireSuperAdmin(),
  component: DataCatalogListPage,
});
